import { Grid, Typography } from "@mui/material";
import UsinaFormsStepper from "../components/UsinaFormsStepper";
import { useState, useRef, useEffect, useContext } from "react";
import MWhValueForm from "../components/MWhValueForm";
import { UsinaFormFooter } from "../components/UsinaFormFooter";
import SupportForm from "../components/SupportForm";
import PVSystForm from "../components/PVSystForm";
// import ComponentsForm from "../components/ComponentsForm";
// import UGsForm from "../components/UGsForm";
import UsinaClusterForm from "../components/UsinaClusterForm";
import { UsinasContext } from "../context/UsinasContextProvider";
import UFVForm from "../components/UFVForm";

export default function NewUsina() {
  const [selectedStep, setSelectedStep] = useState(0);
  const PVSystDataFormRef = useRef<HTMLFormElement | null>(null);
  const MWhValueFormRef = useRef<HTMLFormElement | null>(null);
  // const componentsFormRef = useRef<HTMLFormElement | null>(null);
  // const ugsFormRef = useRef<HTMLFormElement | null>(null);
  const ufvFormRef = useRef<HTMLFormElement | null>(null);
  const supportFormRef = useRef<HTMLFormElement | null>(null);
  const clusterFormRef = useRef<HTMLFormElement | null>(null);
  const handlePVsystFormSubmit = async () => {
    if (PVSystDataFormRef.current) PVSystDataFormRef.current.submitForm();
  };
  const handleMWhFormSubmit = async () => {
    if (MWhValueFormRef.current) MWhValueFormRef.current.submitForm();
  };
  // const handleComponentsFormSubmit = async () => {
  //   if (componentsFormRef.current) componentsFormRef.current.submitForm();
  // };
  // const handleUGsFormSubmit = async () => {
  //   if (ugsFormRef.current) await ugsFormRef.current.submitForm();
  // };
  const handleUFVFormSubmit = async () => {
    if (ufvFormRef.current) await ufvFormRef.current.submitForm();
  };
  const handleSupportFormSubmit = async () => {
    if (supportFormRef.current) await supportFormRef.current.submitForm();
  };
  const handleClusterFormSubmit = async () => {
    if (clusterFormRef.current) await clusterFormRef.current.submitForm();
  };
  function handleNextSubmit() {
    switch (selectedStep) {
      case 0:
        return handlePVsystFormSubmit;
      case 1:
        return handleMWhFormSubmit;
      case 2:
        return handleUFVFormSubmit;
      // case 2:
      //   return handleComponentsFormSubmit;
      // case 3:
      //   return handleUGsFormSubmit;
      case 3:
        return handleSupportFormSubmit;
      case 4:
        return handleClusterFormSubmit;
    }
  }
  const handleNext = () => {
    const submitForm = handleNextSubmit();
    submitForm && submitForm();
  };
  const handleBack = () => {
    setSelectedStep(selectedStep - 1);
  };

  const handleFinish = async () => {
    const submitForm = handleNextSubmit();
    submitForm && (await submitForm());
  };

  const { setUsina } = useContext(UsinasContext);
  const path = window.location.pathname;
  const isRegister = path.includes("cadastrar");
  const onMount = async () => {
    setUsina(null);
  };
  useEffect(() => {
    onMount();
  }, []);

  return (
    <Grid
      style={{
        height: "130vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Grid
        style={{
          width: "90%",
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          {isRegister ? "Cadastrar" : "Editar"} Usina
        </Typography>
      </Grid>
      <Grid
        style={{
          width: "90%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
          marginBottom: "20px",
        }}
      >
        <UsinaFormsStepper activeStep={selectedStep} />
      </Grid>
      <Grid
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {selectedStep === 0 && (
          <PVSystForm
            selectedStep={selectedStep}
            setSelectedStep={setSelectedStep}
            ref={PVSystDataFormRef}
          />
        )}
        {selectedStep === 1 && (
          <MWhValueForm
            selectedStep={selectedStep}
            setSelectedStep={setSelectedStep}
            ref={MWhValueFormRef}
          />
        )}
        {selectedStep === 2 && (
          <UFVForm
            selectedStep={selectedStep}
            setSelectedStep={setSelectedStep}
            ref={ufvFormRef}
          />
        )}
        {/* {selectedStep === 2 && (
          <ComponentsForm
            selectedStep={selectedStep}
            setSelectedStep={setSelectedStep}
            ref={componentsFormRef}
          />
        )}
        {selectedStep === 3 && (
          <UGsForm
            selectedStep={selectedStep}
            setSelectedStep={setSelectedStep}
            ref={ugsFormRef}
          />
        )} */}
        {selectedStep === 3 && (
          <SupportForm
            ref={supportFormRef}
            selectedStep={selectedStep}
            setSelectedStep={setSelectedStep}
          />
        )}
        {selectedStep === 4 && <UsinaClusterForm ref={clusterFormRef} />}
      </Grid>

      <UsinaFormFooter
        selectedStep={selectedStep}
        handleBack={handleBack}
        handleNext={handleNext}
        handleSave={handleFinish}
      />
    </Grid>
  );
}
